<template>
    <Article>
        <template #header>
            <h2>Men of the Marauders</h2>
        </template>
        <template #content>
            <div>
                <h3 style="text-align:center">Evolution of the Casual Detachments to the 5307th</h3>
                <p style="text-align:center">
                    <em>
                        <a
                            href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/44-5307-SO3-5307-Roster.pdf?alt=media"
                            target="_blank"
                        >
                            Download 5307 Roster
                        </a>
                        (Provisional) which includes name, rank, serial number, battalion, and unit
                        for each Marauder.
                    </em>
                </p>
                The Marauders arrived in India in September or October of 1943. They were initially
                known as Casual Detachment 1688 and were divided into 3 battalions&nbsp;&mdash; A,
                B, and C. During this period they trained for the upcoming mission, primarily under
                British control, and were divided into Combat Teams for this training. No formal (in
                writing) assignments were made to these teams. We have managed to find a typed copy
                of the personnel of the Green Combat Team, and that is the only one for which we
                have a true list of the members. Generally, a Battalion was divided into 2 Combat
                Teams by taking one-half of Headquarters Company, Company A, and one-half of Company
                B into one team, and the remaining one-half of Headquarters Company and remaining
                one-half of Company B, and all of Company C for the second Combat Team.
                <p style="text-align:center">
                    <em>
                        <a
                            href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/Evolution-of-Casual-Detachments.pdf?alt=media"
                            target="_blank"
                        >
                            Download &quot;Evolution of Casual Detachments&quot;
                        </a>
                        diagram shown below.
                    </em>
                </p>
                <p style="text-align:center">
                    <img
                        class="aligncenter size-full wp-image-117"
                        src="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/Evolution-of-Casual-Detachments.png?alt=media"
                        alt="Evolution of Casual Detachments"
                        width="731"
                        height="562"
                    />
                </p>

                <p style="text-align:left">
                    <strong>5307 Unit Evolution from Galahad to MARS Task Force.</strong>
                    The Marauders were formally organized as the 5307th Composite Regiment
                    (Provisional) on Jan. 1, 1944, and this was almost immediately changed to 5307th
                    Composite Unit (Provisional). They fought in the Combat Team configuration. By
                    April 1, they were so depleted that the combat teams were reorganized into the H
                    Force (1st Bn), M Force (2nd Bn), and K Force (3rd Bn) and each of the Batalions
                    were supplemented by Chinese Forces. The force names (H, M, and K) were derived
                    from the Commanders&rsquo; names &mdash; H Force was commanded by COL Charles
                    Hunter; M Force by COL George A. McGee, and K Force by COL Henry L. Kinnison. By
                    June 1, the Marauders were severely depleted by disease, wounds, and
                    malnutrition, and an influx of over 2000 men supplementing the original 3000
                    arrived. In addition, the 209th Engr Bn, the 236th Engr Bn, and the 879th Engr
                    Bn was also added. At this point, the operation became popularly known as
                    &quot;New Galahad&quot; although the operation was always officially known as
                    &quot;Galahad&quot;.
                </p>
                <p style="text-align:center">
                    <em>
                        <a
                            href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/Evolution-of-Marauders.pdf?alt=media"
                            target="_blank"
                        >
                            Download the &quot;5307th Composite Unit (Provisional) Evolution of
                            Galahad to
                        </a>
                        <a
                            href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/Evolution-of-Marauders.pdf?alt=media"
                            target="_blank"
                        >
                            New Galahad to MARS Task Force&quot;
                        </a>
                        diagram shown below.
                    </em>
                </p>
                <p style="text-align:center">
                    <img
                        class="aligncenter size-full wp-image-488"
                        src="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/Evolution-of-Marauders.png?alt=media"
                        alt="Evolution-of-Marauders"
                        width="693"
                        height="513"
                    />
                </p>

                <p style="text-align:left">
                    <strong>About the Combat Team Roster.</strong>
                    While training with the British forces under General Orde Wingate, the Marauders
                    were divided into combat teams. Generally, each Battalion was divided pretty
                    close to down the middle &mdash; about half of Headquarters Company, Company A,
                    and about half of Company B forming one combat team. The second then was formed
                    from the remaining portions of Headquarters Company and Company B, and most, if
                    not all, of Company C. Thus the three combat battalions were formed into 6
                    combat teams, and each team was designed by a color. The Red and White Combat
                    Teams from the 1st Battalion, the Blue and Green Combat Teams from the 2nd
                    Battalion, and the Khaki and Orange Combat Teams from the 3rd Battalion. Even
                    after reverting to American command, the Marauders continued to operate in this
                    combat team configuration, administration continued in the traditional company
                    and battalion configuration. Morning Reports were prepared using the company and
                    battalion designations as were promotions, reductions, etc.
                </p>
                <p style="text-align:left">
                    There were no known orders or other documentation prepared which identified the
                    individual soliders assigned to a particular team, and to date at least, only
                    one combat team roster has survived.
                </p>
                <p style="text-align:left">
                    The Green Combat Team Roster was found attached to the Morning Reports submitted
                    by Company G for the month of February 1944. The roster is undated, but must
                    have been prepared in February 1944 or earlier. It was obviously a working copy,
                    as there are several line-outs and additions. It is somewhat unique in that it
                    shows the soldiers&rsquo; names, SN&rsquo;s and their duty assignment with the
                    team. The reason for attaching this roster to the Morning Report is unclear, in
                    that there was no entry referring to this roster. It may have been purely by
                    accident.
                </p>
                <p style="text-align:left">
                    Also included is an extra single page which may not have been part of the
                    original roster. The heading on this page reads &quot;Attached Personnel
                    continued from Page #4&quot; and Page 4 of the Green Combat Team Roster says
                    nothing about Attached Personnel.
                </p>
                <br />
                <p style="text-align:center">
                    <em>
                        Information supplied and prepared by Merrill&rsquo;s Marauders Proud
                        Descendant Historian Hansel L. Haycox.
                    </em>
                </p>
                <p style="text-align:center"></p>
            </div>
        </template>
    </Article>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Article from '@/components/Article/Article.vue';

export default defineComponent({
    name: 'MenOfTheMarauders',
    components: { Article }
});
</script>
